module.exports = __webpack_public_path__ + "prod/1.42.2/img/ggfw.38043309.png";